// :cow: Cosmose CONFIDENTIAL :iso:
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { interval, Subject } from 'rxjs';

@Directive({selector: '[coaTextAnimation]'})
export class TextAnimationDirective implements OnInit, OnDestroy {
  @Input() coaTextAnimation: string[];

  private unsubscribe$ = new Subject();
  private textIndex: number;

  constructor(
    private elementRef: ElementRef,
  ) {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.write(this.getNextTextEntry());
  }

  private getNextTextEntry(): string {
    this.nextIndex();
    return this.coaTextAnimation[this.textIndex];
  }

  private nextIndex(): void {
    if (this.textIndex == null) {
      this.textIndex = 0;
      return;
    }

    if (this.textIndex === this.coaTextAnimation.length - 1) {
      this.textIndex = 0;
      return;
    }

    this.textIndex++;
  }

  private write(text: string): void {
    let index = 0;
    interval(100).pipe(
      take(text.length),
      takeUntil(this.unsubscribe$),
    ).subscribe(() => {
      const textPart = text.substring(0, index + 1);
      this.setText(textPart);
      index++;

      if (index === text.length) {
        this.waitBeforeWriting(this.getNextTextEntry());
      }
    });
  }

  private waitBeforeWriting(text: string): void {
    interval(2000).pipe(
      take(1),
    ).subscribe(() => {
      this.setText('');
      this.write(text);
    });
  }

  private setText(text: string): void {
    this.elementRef.nativeElement.innerHTML = text;
  }
}
